import { render, staticRenderFns } from "./OtpDefault.vue?vue&type=template&id=1f988c66&scoped=true"
import script from "./OtpDefault.vue?vue&type=script&lang=js"
export * from "./OtpDefault.vue?vue&type=script&lang=js"
import style0 from "./OtpDefault.vue?vue&type=style&index=0&id=1f988c66&prod&lang=scss"
import style1 from "./OtpDefault.vue?vue&type=style&index=1&id=1f988c66&prod&scoped=true&lang=css"
import style2 from "./OtpDefault.vue?vue&type=style&index=2&id=1f988c66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f988c66",
  null
  
)

export default component.exports